import CashRecharge from '@/views/webpc/CashierDesk/CashRechargeApp/CashRecharge'

// 定义路由路径数列表
export default [{
  path: '/cashRecharge',
  name: '现金充值',
  component: CashRecharge
}]



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/CashRechargeApp/routers/index.js